import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const SquareCheckIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="checkbox-check" {...props} />;
};

export { SquareCheckIcon };
